import { useCallback, useState } from 'react';
import type { EventInstance } from '@/features/events/lib/eventInstance.lib';
import type { DecoratedEvent } from '@/features/events/types';
import type { EventModalMessage } from '../types';
import { createNewEventMessage } from '../utils';

// Deep links into the event modal (e.g. from the customize Text-messages view)
// set this param to open the texts panel; the modal strips it after handling.
export const TEXTS_QUERY_PARAM = 'texts';

// The message the texts panel is composing or editing. Whether that panel is
// *open* is not this hook's business — useEventModalPanels owns that for every
// panel — so this is only the draft, cleared by the controller when the panel
// goes away. Handlers are memoized so consumers can list them in effect deps.
export const useEventMessagesPanelState = () => {
  const [activeMessage, setActiveMessage] = useState<EventModalMessage>();

  const createNewMessage = useCallback(
    (event: DecoratedEvent, instance: EventInstance) => {
      setActiveMessage(createNewEventMessage(event, instance));
    },
    []
  );

  const editMessage = useCallback((message: EventModalMessage) => {
    setActiveMessage(message);
  }, []);

  const clearActiveMessage = useCallback(() => {
    setActiveMessage(undefined);
  }, []);

  return {
    activeMessage,
    createNewMessage,
    editMessage,
    clearActiveMessage,
  };
};
